import Accordion from 'accordion-js';

const faq_accordion = new Accordion('.accordion-container', {
  duration: 400,
  showMultiple: true,
});
